<template>
  <div id="intent">
    <template v-if="!loading">
      <v-container>
        <slot name="header"></slot>
        <v-layout v-if="!isGetstarted" wrap>
          <v-flex xs12 sm6 class="form-control">
            <input
              v-model="search"
              type="text"
              class="form-control"
              :placeholder="$t('Search Conversation Name')"
              style="margin-bottom: 10px"
              @keydown.enter="onSearch"
              @input="onSearch"
            />
          </v-flex>
          <v-flex xs12 sm6 class="form-control text-xs-right">
            <v-btn
              v-if="['dtac-gaming'].includes(selectedBot.type)"
              class="ma-0 mb-1 mr-1"
              color="primary"
              outline
              @click="updateDtacGameIntent"
            >
              {{ $t('Update') }}
            </v-btn>
            <v-btn class="ma-0 mb-1 mr-1" color="primary" outline @click="expandAll">
              <em class="fas fa-expand-arrows-alt mr-1" />
              {{ $t('Expand All') }}
            </v-btn>
            <v-btn class="ma-0 mb-1 mr-1" color="primary" outline @click="collapseAll">
              <em class="fas fa-compress mr-1" />
              {{ $t('Collapse All') }}
            </v-btn>
            <v-btn
              v-if="selectedBot && selectedBot.type === 'gpf'"
              class="ma-0 mb-1 mr-1"
              color="primary"
              outline
              @click="exportIntents"
            >
              <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
            </v-btn>
          </v-flex>
        </v-layout>
        <div v-if="$store.state.toaPaintPage.includes(selectedBot.pageid)" class="my-3">
          <v-layout v-if="!livechat">
            <v-flex xs10>
              <h6 class="headline mb-2">{{ $t('Conversation Grouping') }}</h6>
              <!-- <v-btn
                :key="'all'"
                class="ma-0 mr-1 mb-1"
                depressed
                :outline="currentFilterGroup != 'all'"
                :color="currentFilterGroup == 'all' ? 'primary' : 'grey'"
                @click="onFilterGroupChange('all')"
                >All</v-btn
              > -->
              <!-- {{ filterGroupConversation }} -->
              <template v-for="option in filterGroupConversation">
                <v-btn
                  v-if="option.status"
                  :key="option.id"
                  class="ma-0 mr-1 mb-1"
                  depressed
                  :outline="currentFilterGroup != option.id"
                  :color="currentFilterGroup == option.id ? 'primary' : 'grey'"
                  @click="onFilterGroupChange(option.id)"
                  >{{ option.name }}</v-btn
                >
              </template>
            </v-flex>
            <v-flex xs2 class="text-xs-right">
              <v-btn fab outline color="primary" class="extra-small mt-2" @click="showGroup = true">
                <em class="fas fa-pencil-alt" />
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout v-else>
            <v-flex xs12>
              <div class="caption mt-2">{{ $t('Conversation Grouping') }}</div>
              <multiselect
                v-model="livechatFilterGroupConversation"
                :options="filterGroupConversation"
                select-label
                selected-label
                :searchable="true"
                deselect-label
                label="name"
                track-by="id"
                :allow-empty="false"
                @input="onLivechatFilterGroupConversation"
              ></multiselect>
            </v-flex>
          </v-layout>
          <ConversationGrouping
            v-model="grouplist"
            :show="showGroup"
            @close="showGroup = false"
            @onCategoryChange="onCategoryChange"
            @deleteCategory="deleteCategory"
          ></ConversationGrouping>
        </div>
        <template v-if="isJuzmatchSale || isJuzmatchCrm">
          <v-layout wrap>
            <v-flex xs6>
              <div class="pb-1 primary--text">Filter :</div>
              <multiselect
                v-model="currentFilterRole"
                :options="roleJuzMatchMasterData"
                select-label
                selected-label
                :searchable="true"
                deselect-label
                label="name"
                track-by="id"
                style="margin-bottom: 10px"
                @input="handleFilterRole"
              ></multiselect
            ></v-flex>
          </v-layout>
        </template>

        <div v-if="isRoots" class="my-3">
          <v-layout wrap>
            <v-flex xs12 sm6>
              <h6 class="headline mb-2">Filter :</h6>
              <multiselect
                v-model="currentFilterCompany"
                :options="filterRootsCompany"
                name="rootsCompany"
                :searchable="true"
                select-label
                selected-label
                deselect-label
                label="name"
                track-by="id"
                @input="handleFilterCompanyChange"
              ></multiselect>
            </v-flex>
          </v-layout>
        </div>

        <template v-if="!livechat || ['ticket2', 'studio7', 'ustore'].includes(selectedBot.theme)">
          <div v-if="!isShow" :style="`margin-bottom: 10px; position: relative;`">
            <a href="javascript:void(0);" style="text-decoration: none" @click="addConversation">
              <div class="add-conversation text-xs-center">
                <em class="fa fa-plus middle" />
                {{ $t('Add conversation') }}
              </div>
            </a>
          </div>

          <div v-if="selectedBot.theme == 'universalutilities'" class="mb-4">
            <div v-if="selectedBot.uu_areaname" class="primary--text">
              {{ selectedBot.uu_areaname }}
            </div>
            <template v-else>
              <multiselect
                v-model="uuAreaName"
                v-validate="'required'"
                :options="areaName"
                select-label
                selected-label
                :searchable="false"
                deselect-label
                data-vv-as="ประปา"
                data-vv-name="uuAreaName"
                @select="onSelectUuAreaName"
              ></multiselect>
            </template>
          </div>
          <div v-if="isShow" class="intent-item z-border-red" style="padding: 10px 15px 0px">
            <manage-intent
              v-model="intent"
              :livechat="livechat"
              :type="'add'"
              :excluded-intent-name="excludedIntentName"
              @close="onClose"
              @saveIntent="onSaveIntent"
            ></manage-intent>
          </div>
        </template>
        <Pagination
          :key="timestamp"
          v-model="pageNumber"
          :limit="limit"
          :total="total"
          @onChange="handleChangePage"
        >
          <intent-item
            v-for="(item, index) in filterIntents"
            :key="'intent_' + item.id + '_' + index"
            v-model="filterIntents[index]"
            :livechat="livechat"
            :filter-intents="filterIntents"
            :excluded-intent-name="excludedIntentName"
            @sendToLivechat="sendToLivechat"
            @onDelete="deleteIntent(index)"
            @onCopyIntent="copyIntent"
            @onUpdate="onUpdateIntent"
          />
          <div v-if="filterIntents.length == 0" class="my-4 text-xs-center">
            {{ $t('No data') }}
          </div>
        </Pagination>
      </v-container>
      <template v-if="showDefault">
        <v-divider></v-divider>

        <v-container>
          <h3 class="headline">{{ $t('Default Conversation') }}</h3>
          <intent-item v-model="default_intent" :welcomemessage="welcome_message"></intent-item>
        </v-container>
      </template>
      <div class="mt-5 mb-5"></div>
    </template>
    <div v-else>
      <v-layout justify-center column fill-height style="min-height: 300px">
        <scale-loader
          :loading="true"
          :color="$vuetify.theme.primary"
          height="45px"
          width="7px"
        ></scale-loader>
      </v-layout>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import hopinnHrApi from '@/api/hopinn-hr'
import gpfBuddyApi from '@/api/gpf-buddy'
import rootsApi from '@/api/roots'
import cloneDeep from 'lodash/cloneDeep'
import Multiselect from 'vue-multiselect'
import ConversationGrouping from './ConversationGrouping'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import { mapGetters, mapState } from 'vuex'
import intentItem from './intent-item'
import manageIntent from './intent-manage'
import XLSX from 'xlsx'
import intentApi from '@/api/intent.js'
import { handleResponse, handleApiError } from '@/api/util'
import Pagination from '@/components/elements/Pagination2.vue'
import moment from 'moment'
import powerbuyShopServicesApi from '@/api/powerbuy-shop-services'
import { PAGE } from '@/constants/page.js'
import dtacGamingApi from '@/api/dtac-gaming'

export default {
  components: {
    'manage-intent': manageIntent,
    'intent-item': intentItem,
    Multiselect,
    ScaleLoader,
    Pagination,
    ConversationGrouping
  },
  props: {
    showDefault: {
      default: true,
      type: Boolean
    },
    isGetstarted: {
      default: false,
      type: Boolean
    },
    filterContext: {
      default: null
    },
    pageid: {
      default: null
    },
    livechat: {
      default: false
    }
  },
  data() {
    return {
      showPagination: false,
      pageNumber: 1,
      isShow: false,
      showsize: 50,
      showModal: false,
      uuAreaName: '',
      loading: true,
      intent: {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: '',
        context_in: '',
        context_out: '',
        postidlist: '',
        userstatus: '',
        usertags: '',
        isShow: false,
        linenoti_status: false,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true,
        follow_up_fb_quick_reply: null,
        follow_up_fb_val: null,
        follow_up_ig_quick_reply: null,
        follow_up_ig_val: null,
        follow_up_line_quick_reply: null,
        follow_up_line_val: null,
        follow_up_quick_reply: null,
        follow_up_status: null,
        follow_up_type: null,
        follow_up_val: null,
        follow_up_within_seconds: null
      },
      allIntents: [],
      intents: [],
      welcome_message: {
        message: '',
        generics: [],
        type: '',
        quick_reply: []
      },
      isSave: false,
      lastedIntentName: '',
      default_intent: undefined,
      currentpageid: null,
      limit: 20,
      offset: 0,
      total: 0,
      search: '',
      searchTimeout: null,
      timestamp: moment().format('x'),
      grouplist: undefined,
      showGroup: false,
      currentFilterGroup: 'all',
      livechatFilterGroupConversation: [{ id: 'all', name: 'All', status: true }],
      currentFilterRole: { id: 'All', name: 'ทั้งหมด' },
      currentFilterCompany: { id: 'all', name: 'All' }
    }
  },
  computed: {
    ...mapState({
      userid: 'userid'
    }),
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageCount: function () {
      let l = this.filterIntents.length
      let s = this.showsize
      return Math.ceil(l / s)
    },
    filterIntents: function () {
      var vm = this
      var intents = vm.intents
      if (this.filterContext)
        intents = intents.filter((el) => {
          return el.context_in == this.filterContext
        })
      if (vm.selectedBot.theme !== 'tero') {
        intents.sort(function (a, b) {
          var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
          var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
          if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
            return 1
          }
          if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
            return -1
          }
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }

          // names must be equal
          return 0
        })
      }
      return intents
    },

    roleJuzMatchMasterData() {
      if (this.isJuzmatchCrm) {
        return this.$store.state.juzMatchMasterDataCrm || []
      } else {
        return this.$store.state.juzMatchMasterDataSale || []
      }
    },

    filterRole() {
      let roles = [{ id: 'All', name: 'ทั้งหมด' }]
      if (this.roleJuzMatchMasterData && this.roleJuzMatchMasterData.length > 0) {
        let tempRole = []
        this.roleJuzMatchMasterData.forEach((el) => {
          tempRole.push({
            id: el.id,
            name: el.name
          })
        })
        roles.push(...tempRole)
      }
      return roles
    },

    excludedIntentName: function () {
      const result = this.allIntents.map((intent) => intent.intentname, [])
      return result.join(',')
    },
    areaName: function () {
      var areaName = ['ทุกพื้นที่'].concat(this.$store.state.uuAreaName)
      return areaName
    },
    totalIntentWithoutDefault() {
      var intentwithoutwelcome = this.intents.filter((el) => {
        return !['{welcome}', '{default}', '{default_comment_to_inbox}', '{default_live}'].includes(
          el.intentname
        )
      })
      return intentwithoutwelcome.length
    },
    filterGroupConversation() {
      var group = [{ id: 'all', name: 'All', status: true }]
      var groupConversation = this.$store.state.groupConversation
      group.push(...groupConversation)
      return group
    },
    rootsCompanyMasterData() {
      return this.$store.state.rootsMasterData.company
    },
    filterRootsCompany() {
      // let companys = []
      // if (this.rootsMasterData) {
      //   companys = [{ id: 'all', name: 'All' }, ...this.rootsMasterData]
      // }
      // return companys

      let options = [{ id: 'all', name: 'All' }]
      if (this.rootsCompanyMasterData) {
        let tempCompanies = []
        this.rootsCompanyMasterData.forEach((el) => {
          tempCompanies.push({
            id: el.id,
            name: `${el.company_code} - ${el.company_name}`
          })
        })
        options.push(...tempCompanies)
      }
      return options
    },
    isGpfBuddy() {
      return PAGE.GPF_BUDDY.includes(this.selectedBot.pageid)
    },
    isJuzmatchSale() {
      return PAGE.JUZMATCH_SALE.includes(this.selectedBot.pageid)
    },
    isJuzmatchCrm() {
      return PAGE.JUZMATCH_CRM.includes(this.selectedBot.pageid)
    },
    isRoots() {
      return PAGE.ROOTS.includes(this.selectedBot.pageid)
    }
  },
  async mounted() {
    var vm = this
    if (this.pageid) {
      this.currentpageid = this.pageid
    } else {
      this.currentpageid = this.selectedBot.pageid
    }

    this.loading = true
    if (this.$store.state.toaPaintPage.includes(this.selectedBot.pageid)) {
      await this.$store.dispatch('loadGroupConversation')
      this.grouplist = this.$store.state.groupConversation
    }
    this.getLineNotify()
    try {
      await this.getWelcomeMessage()
    } catch (error) {
      console.error(error)
    }
    await this.getIntent()
    await this.handleInitDefaultMessage()
    this.$emit('getIntent', this.intents)

    this.loading = false

    if (vm.selectedBot && vm.selectedBot.type === 'hopinnhr') {
      await vm.getHopinnHrAffiliation()
      await vm.getHopinnHrPosition()
    }

    if (vm.isGpfBuddy) {
      await vm.getGpfBuddyMasterData()
    }

    if (vm.isRoots) {
      await vm.getRootsMasterData()
    }

    if (['powerbuy'].includes(vm.selectedBot.theme)) {
      await vm.handlePowerbuyCheckBranch()
    }

    if (
      (this.selectedBot.theme == 'ecommercebasic' ||
        this.$store.state.shoptheme.includes(this.selectedBot.theme)) &&
      !['allinonechat'].includes(this.$route.name)
    ) {
      await this.$store.dispatch('loadCategory')
      await this.$store.dispatch('loadProducts')
      await this.$store.dispatch('loadCharges')
    }
    if (
      ['ticket', 'ticket2', 'studio7', 'ustore', 'cityfresh', 'ttb'].includes(
        this.selectedBot.theme
      ) ||
      [...this.$store.state.ticketPageid, ...this.$store.state.toaPaintPage].includes(
        this.selectedBot.pageid
      ) ||
      ['gpf', 'mtc'].includes(this.selectedBot.type)
    ) {
      await this.$store.dispatch('loadAgents')
      await this.$store.dispatch('loadAgentGroups')
      await this.$store.dispatch('loadAgentSubGroups')
    }

    if (['mitsuwebchat'].includes(this.selectedBot.theme)) {
      await this.$store.dispatch('loadAgentGroups')
    }

    if (['toa'].includes(this.selectedBot.theme)) {
      this.$store.dispatch('getTicketTags')
    }

    this.$store.dispatch('loadSetting')
  },
  methods: {
    onSearch() {
      const vm = this
      if (vm.searchTimeout) {
        clearTimeout(vm.searchTimeout)
      }
      if (vm.loading) return false
      vm.searchTimeout = setTimeout(async () => {
        vm.$store.dispatch('loading')
        try {
          vm.offset = 0
          vm.pageNumber = 1
          vm.timestamp = moment().format('x')
          await vm.getIntent()
        } catch (error) {
          console.error(error)
        }
        vm.$store.dispatch('loading')
        vm.searchTimeout = null
      }, 1000)
    },
    async handleFilterRole(value) {
      const vm = this
      vm.$store.dispatch('loading')
      try {
        vm.currentFilterRole = value
        vm.offset = 0
        vm.pageNumber = 1
        vm.timestamp = moment().format('x')
        await vm.getIntent()
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
      vm.$store.dispatch('loading')
    },
    async handleChangePage(payload) {
      this.$store.dispatch('loading')
      this.offset = payload.offset
      await this.getIntent()
      this.$store.dispatch('loading')
    },
    sendToLivechat(intent) {
      this.$emit('sendToLivechat', intent)
    },
    async onSelectUuAreaName(type) {
      this.$store.dispatch('loading')
      this.uuAreaName = type == 'ทุกพื้นที่' ? '' : type
      await this.getIntent()
      this.$store.dispatch('loading')
    },
    getLineNotify: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getLineNotify({ pageid: vm.currentpageid }, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.linenotifylist) {
            vm.$store.state.linenotifylist = response.linenotifylist
          }
          resolve()
        })
      })
    },
    async onSaveIntent(payload) {
      this.$store.commit('REMOVE_EDITTING_INTENT', 'ADD_INTENT')
      this.isShow = false
      payload.isShow = true
      this.intent = cloneDeep(this.intentTemplate())
      await this.handleChangeIntent({ intent_name: payload.intent_name })
      this.onClose()
      await this.$swal.fire({
        // eslint-disable-next-line no-useless-escape
        title: `${this.$t('conversation')} ${payload.intentname.replace(/\<|\>/g, '')} ${this.$t(
          'added'
        )}`,
        type: 'success',
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
    },
    async copyIntent(payload) {
      if (this.$store.getters.getPackage != 'premium' && this.totalIntentWithoutDefault >= 10) {
        const result = await this.$swal.fire({
          html: `<b class="intentmax"> ${this.$t(
            'if you want to add more conversation, <br/>please upgrade to premium'
          )}</b>`,
          confirmButtonText: this.$t('Upgrade now'),
          confirmButtonColor: this.$vuetify.theme.primary
        })
        if (result.value) {
          this.$router.push('Upgrade')
        }
      } else if (
        this.$store.getters.getPackage == 'premium' &&
        this.totalIntentWithoutDefault.length >= 300 &&
        !this.$store.state.UnlimitedConversation.includes(this.currentpageid) &&
        this.selectedBot.pagetype !== 'enterprise'
      ) {
        const result = await this.$swal.fire({
          html: `<b class="intentmax"> ${this.$t('Please contact us')}</b>`,
          confirmButtonText: this.$t('Contact us'),
          confirmButtonColor: this.$vuetify.theme.primary
        })
        if (result.value) {
          window.location.assign('https://www.facebook.com/messages/t/zwizai')
        }
      } else {
        const result = await payload.onCopy()
        result.isShow = true
        this.intents.push(result)
        this.allIntents.push(result)
        await this.$swal.fire({
          // eslint-disable-next-line no-useless-escape
          title: `${this.$t('conversation')} ${result.intentname.replace(/\<|\>/g, '')} ${this.$t(
            'added'
          )}`,
          type: 'success',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
      }
    },
    onClose: function () {
      this.isShow = false
      this.$store.commit('REMOVE_EDITTING_INTENT', 'ADD_INTENT')
    },
    async getIntent(intentType = 'conversation', intent_name = []) {
      let data = {
        pageid: this.currentpageid,
        limit: this.limit,
        offset: this.offset,
        page_intent: intentType,
        search_intent: this.search && this.search.trim() ? this.search.trim() : undefined,
        intent_name:
          intent_name.length > 0 ? `[${intent_name.map((el) => `"${el}"`).join(',')}]` : undefined,
        sort_by: 'intentname',
        sort_type_available: 'asc'
      }

      if (this.selectedBot.theme == 'universalutilities') {
        if (this.selectedBot.uu_areaname) {
          data.intentgroup = this.selectedBot.uu_areaname
        } else if (this.uuAreaName != '') {
          data.intentgroup = this.uuAreaName
        }
      }

      if (['mitsuwebchat'].includes(this.selectedBot.theme)) {
        if (this.$store.state.privilege.role !== 'superadmin' && this.$store.state.admingroupid) {
          data.intentgroup = this.$store.state.admingroupid
        }
      }

      if (this.$store.state.toaPaintPage.includes(this.selectedBot.pageid)) {
        if (this.currentFilterGroup !== 'all') {
          data.group_conversation_id = this.currentFilterGroup
        }
      }

      if (this.isJuzmatchSale || this.isJuzmatchCrm) {
        if (this.currentFilterRole && this.currentFilterRole.id !== 'All') {
          data.intent_member_type = this.currentFilterRole.id
        }
      }

      if (this.isRoots) {
        if (this.currentFilterCompany && this.currentFilterCompany.id !== 'all') {
          data.roots_company_id = this.currentFilterCompany.id
        }
      }

      try {
        this.total = 0
        const response = await intentApi.getIntent({ params: data })
        await handleResponse(response)
        if (response.status == 200 && response.data.data) {
          const intents = response.data.data.map(function (val) {
            return { ...val, isShow: false, ableToDelete: true }
          })
          this.total = response.data.total_count || 0
          this.$emit('handleSetCountIntent', this.total)
          this.allIntents = intents
          this.intents = intents.filter((el) => {
            return (
              el.context_in != 'comment' &&
              el.intentname != '{default}' &&
              el.intentname != '{welcome}'
            )
          })
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    async handleInitDefaultMessage(intentType = 'conversation', intent_name = ['{default}']) {
      let data = {
        pageid: this.currentpageid,
        limit: this.limit,
        offset: this.offset,
        page_intent: intentType,
        search_intent: this.search && this.search.trim() ? this.search.trim() : undefined,
        intent_name: `[${intent_name.map((el) => `"${el}"`).join(',')}]`,
        sort_by: 'intentname',
        sort_type_available: 'asc'
      }
      const response = await intentApi.getIntent({ params: data })
      await handleResponse(response)
      if (response.status == 200 && response.data.data) {
        const intents = response.data.data.map(function (val) {
          return { ...val, isShow: false, ableToDelete: true }
        })
        var default_intent = intents.find((el) => {
          return el.intentname == '{default}'
        })

        if (default_intent) {
          default_intent.ableToDelete = false
          this.default_intent = default_intent
        } else {
          this.default_intent = {
            ...cloneDeep(this.intentTemplate()),
            intentname: '{default}',
            ableToDelete: false
          }
        }
      }
    },
    async deleteIntent(index) {
      const result = await this.$swal.fire({
        title: this.$t('Do you want to delete {name}?', {
          // eslint-disable-next-line no-useless-escape
          name: this.filterIntents[index].intentname.replace(/\<|\>/g, '')
        }),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        let data = {
          id: this.filterIntents[index].id,
          pageid: this.currentpageid
        }
        this.$store.dispatch('loading')
        try {
          const response = await intentApi.deleteIntent({ params: data })
          await handleResponse(response)
          await this.handleChangeIntent({ intent_name: this.filterIntents[index].intent_name })
        } catch (error) {
          handleApiError(error)
        }
        this.$store.dispatch('loading')
      }
    },
    async handleChangeIntent({ intent_name }) {
      switch (intent_name) {
        case '{default}':
        case '{default_comment_to_inbox}':
        case '{default_live}':
          await this.handleInitDefaultMessage()
          break
        default:
          await this.getIntent()
          break
      }
    },
    getWelcomeMessage: function () {
      let vm = this
      let data = {
        pageid: vm.currentpageid
      }

      vm.welcome_message.message = null
      vm.welcome_message.generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        }
      ]
      vm.welcome_message.type = 'message'
      return new Promise((resolve, reject) => {
        api.getWelcomeMessage(data, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            vm.welcome_message.type = response.data.type
            vm.welcome_message.message = response.data.message_text
              ? response.data.message_text
              : ''

            if (
              response.data.message &&
              typeof response.data.message === 'object' &&
              response.data.message.length > 0
            ) {
              vm.welcome_message.generics = response.data.message.map((message) => message, [])
            }

            if (
              response.data.message_quickreplies &&
              response.data.message_quickreplies != '' &&
              response.data.message_quickreplies != null
            ) {
              vm.welcome_message.quick_reply = response.data.message_quickreplies.split(',')
            } else {
              vm.welcome_message.quick_reply = []
            }
          }
          resolve()
        })
      })
    },
    async addConversation() {
      if (this.$store.getters.getPackage != 'premium' && this.totalIntentWithoutDefault >= 10) {
        const result = await this.$swal.fire({
          html: `<b class="intentmax"> ${this.$t(
            'if you want to add more conversation, <br/>please upgrade to premium'
          )}</b>`,
          confirmButtonText: this.$t('Upgrade now'),
          confirmButtonColor: this.$vuetify.theme.primary
        })
        if (result.value) {
          this.$router.push('Upgrade')
        }
      } else if (
        this.$store.getters.getPackage == 'premium' &&
        this.totalIntentWithoutDefault >= 300 &&
        !this.$store.state.UnlimitedConversation.includes(this.currentpageid) &&
        this.selectedBot.pagetype !== 'enterprise'
      ) {
        const result = await this.$swal.fire({
          html: `<b class="intentmax"> ${this.$t('Please contact us')}</b>`,
          confirmButtonText: this.$t('Contact us'),
          confirmButtonColor: this.$vuetify.theme.primary
        })
        if (result.value) {
          window.location.assign('https://www.facebook.com/messages/t/zwizai')
        }
      } else {
        this.$store.commit('ADD_EDITTING_INTENT', 'ADD_INTENT')
        this.isShow = true
      }
    },
    expandAll: function () {
      this.intents = this.intents.map((intent) => {
        return { ...intent, isShow: true }
      })
      this.$set(this.default_intent, 'isShow', true)
    },
    collapseAll: function () {
      this.intents = this.intents.map((intent) => {
        return { ...intent, isShow: false }
      })
      this.$set(this.default_intent, 'isShow', false)
    },
    onUpdateIntent: function (payload) {
      const index = this.intents.findIndex((intent) => {
        return intent.id == payload.id
      })
      if (index > -1) {
        Object.assign(payload, {
          updated_at: new Date().toISOString(),
          update_by: this.userid
        })
        this.$set(this.intents, index, payload)
      }
    },
    async onFilterGroupChange(value) {
      const vm = this
      vm.currentFilterGroup = value
      await vm.getIntent()
    },
    async handleFilterCompanyChange(value) {
      this.currentFilterCompany = value
      await this.getIntent()
    },
    async onLivechatFilterGroupConversation(value) {
      let vm = this
      let currentFilterId = value.id
      vm.currentFilterGroup = value.id

      let selectedConversationGroup = this.filterGroupConversation.find(
        (el) => el.id == currentFilterId
      )
      this.$set(this.livechatFilterGroupConversation, selectedConversationGroup)
      await vm.getIntent()
    },
    onCategoryChange: function () {
      //
    },
    deleteCategory(groupid) {
      this.grouplist = this.grouplist.filter((el) => {
        return el.id != groupid
      })
      if (this.currentFilterGroup == groupid) {
        this.setDefaultCategory()
      }
    },
    setDefaultCategory() {
      if (this.selectedBot.theme == 'nvbb' && this.categorylist.length > 0) {
        this.currentFilterGroup = this.categorylist[0].id
      } else {
        this.currentFilterGroup = 'all'
      }
    },
    async getHopinnHrAffiliation() {
      try {
        const response = await hopinnHrApi.getAffiliation()
        if (response && response.data.responsecode == 200) {
          this.$store.state.hopinnMasterData.affiliation = response.data.data
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    async getHopinnHrPosition() {
      try {
        const response = await hopinnHrApi.getPosition()
        if (response && response.data.responsecode == 200) {
          this.$store.state.position = response.data.data
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    async getGpfBuddyMasterData() {
      const vm = this
      try {
        const data = {
          pageId: vm.selectedBot.pageid
        }
        const response = await gpfBuddyApi.getCompanyMasterData({ config: data })
        if (response && response.status === 200) {
          vm.$store.state.gpfBuddyMasterData = response.data.data
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    async getRootsMasterData() {
      const vm = this
      try {
        const pageId = vm.selectedBot.pageid
        const response = await rootsApi.getCompany({ pageId })
        if (response && response.status === 200) {
          vm.$store.state.rootsMasterData.company = response.data.data
        }
      } catch (error) {
        console.error(error)
        return
      }
    },

    exportIntents() {
      const allIntents = this.allIntents
      const intents = allIntents.map((intent) => {
        return {
          id: intent.id,
          intent_name: intent.intentname,
          question: intent.q_val,
          answer: intent.a_val,
          status: intent.intentstatus == true ? 'Active' : 'Inactive'
        }
      })
      const heading = [['Id', 'Intent Name', 'Question', 'Answer', 'Status']]
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.sheet_add_json(ws, intents, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `GPF-intents.xlsx`)
    },
    async handlePowerbuyCheckBranch() {
      const vm = this
      try {
        let data = {
          pageId: vm.selectedBot.pageid
        }

        vm.$store.dispatch('loading')
        const response = await powerbuyShopServicesApi.checkBranch({
          config: {
            params: data
          }
        })

        vm.$store.dispatch('loading')
        if (response && response.status === 200) {
          vm.$store.state.powerbuyMainBranch = response.data.shop_main_pageid
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    },

    async updateDtacGameIntent() {
      try {
        await dtacGamingApi.syncGames({ data: { page_id: this.selectedBot.pageid } })
        await this.getIntent()
        this.$swal.fire({
          type: 'success',
          title: 'อัพเดทสำเร็จ'
        })
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          type: 'error',
          title: 'System error'
        })
      }
    }
  }
}
</script>

<style>
.intentmax {
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/Intent.vue